module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_allPointsList.c9c90b9d.bin";